import { render, staticRenderFns } from "./DeadlinesCalendar.vue?vue&type=template&id=d60ad906&scoped=true"
import script from "./DeadlinesCalendar.vue?vue&type=script&lang=js"
export * from "./DeadlinesCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60ad906",
  null
  
)

export default component.exports